import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const companyInvoiceTemplates = [
  {
    id: '-130005',
    language: Language.EN,
    subject: 'Invoice {{invoice.invoiceNumber}}',
    type: TemplateType.MAIL,
    subType: TemplateSubType.COMPANY_INVOICE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{getContactName contact}},</p>
        <p></p>
        <p>Please find attached the invoice related to the management of your real estate property(ies).</p>
        <p></p>
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-130006',
    language: Language.FR,
    subject: 'Facture {{invoice.invoiceNumber}}',
    type: TemplateType.MAIL,
    subType: TemplateSubType.COMPANY_INVOICE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher {{getContactName contact}},</p>
        <p></p>
        <p>Nous vous prions de prendre connaissance de la facture en pièce jointe relative à la gestion de votre/vos bien(s) immobilier(s).</p>
        <p></p>
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-130007',
    language: Language.NL,
    subject: 'Factuur {{invoice.invoiceNumber}}',
    type: TemplateType.MAIL,
    subType: TemplateSubType.COMPANY_INVOICE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{getContactName contact}},</p>
        <p></p>
        <p>In bijlage vindt u de factuur met betrekking tot het beheer van uw vastgoed.</p>
        <p></p>
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-130008',
    language: Language.DE,
    subject: 'Rechnung {{invoice.invoiceNumber}}',
    type: TemplateType.MAIL,
    subType: TemplateSubType.COMPANY_INVOICE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{getContactName contact}},</p>
        <p></p>
        <p>Bitte finden Sie anbei die Rechnung zur Verwaltung Ihrer Immobilie(n).</p>
        <p></p>
        {{#if correctedVersionNote}}
        <p style="white-space: pre-line">{{correctedVersionNote}}</p>
        <p></p>
        {{/if}}
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
